// @flow
import React, { Component } from 'react';
import HeaderBlock from './HeaderBlock';
import { PartnersWrapperDiv } from './PartnersStyles';
import { Route } from 'react-router-dom';
import ReferredPartnersIndex from './ReferredPartnersIndex';
import ReferredPartnersShow from './ReferredPartnersShow';
import FilterBlock from './FilterBlock';
// import ReferAPartner from './ReferAPartner';

type Props = {};

export type TooltipProps = {
  activeTooltip: string,
  showTooltip: () => void
};

export default class PartnersPage extends Component<Props> {
  handleReferredIndex = () => (
    <>
      <FilterBlock />
      <ReferredPartnersIndex />
    </>
  );
  handleReferredShow = (props: {}) => (
    <>
      <FilterBlock />
      <ReferredPartnersShow {...props} />
    </>
  );
  render() {
    return (
      <PartnersWrapperDiv>
        <HeaderBlock />
        <Route
          exact
          path="/partners/referred"
          render={() => this.handleReferredIndex()}
        />
        <Route
          exact
          path="/partners/referred/:id"
          render={props => this.handleReferredShow(props)}
        />
        {/* <Route
          exact
          path="/partners/refer-a-partner"
          component={ReferAPartner} //TODO: TOMORROW
        /> */}
      </PartnersWrapperDiv>
    );
  }
}
